import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import "./Certificaten.css";
import Sikkens from "../../assets/img/partners/sikkens.jpg";
import ABS from "../../assets/img/partners/abs.jpg";
import Acoat from "../../assets/img/partners/acoat.webp";
import Arval from "../../assets/img/partners/arval.png";
import Ayvens from "../../assets/img/partners/ayv_logoe_sereneblue.webp";
import Athlon from "../../assets/img/partners/Athlon_2019_logo_pos_RGB.png";

/* Irregular grid: spanCol x spanRow (1 or 2) for bento-style layout */
const partners = [
  { name: "Sikkens", img: Sikkens, spanCol: 2, spanRow: 1 },
  { name: "ABS", img: ABS, spanCol: 1, spanRow: 1 },
  { name: "Acoat", img: Acoat, spanCol: 1, spanRow: 1 },
  { name: "Arval", img: Arval, spanCol: 1, spanRow: 1 },
  { name: "Ayvens", img: Ayvens, spanCol: 1, spanRow: 1 },
  { name: "Athlon", img: Athlon, spanCol: 2, spanRow: 1 },
];

export default function Certificaten() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-10%" });

  return (
    <section id="partners" className="partners-section" ref={ref}>
      <div className="partners-container">
        <motion.div
          className="partners-header"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <span className="section-badge">Partners</span>
          <motion.h2
            className="partners-title"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={
              isInView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.9 }
            }
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            Onze partners
          </motion.h2>
        </motion.div>

        <motion.div
          className="partners-grid-wrapper"
          initial={{ opacity: 0, y: 40 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 40 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <div className="partners-bento-grid">
            {partners.map((partner, index) => (
              <motion.div
                key={partner.name}
                className="partners-tile"
                style={{
                  gridColumn: `span ${partner.spanCol}`,
                  gridRow: `span ${partner.spanRow}`,
                }}
                initial={{ opacity: 0, scale: 0.85 }}
                animate={
                  isInView
                    ? { opacity: 1, scale: 1 }
                    : { opacity: 0, scale: 0.85 }
                }
                transition={{
                  duration: 0.5,
                  delay: 0.1 * index,
                  ease: "easeOut",
                }}
              >
                <div className="partner-logo-container">
                  <img
                    src={partner.img}
                    alt={partner.name}
                    className="partner-logo-image"
                    loading="lazy"
                  />
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
